<template>
    <div>
        <div class="widget_heading mb-3">
            <h5 class="text-sidebar text-left">
                Diligencie la siguiente información, uno de nuestros
                asesores se pondrá en contacto con usted para
                brindarle una mejor asesoría.
            </h5>
            <span class="float-right text-danger">
              Los campos con (*) son obligatorios
            </span>
        </div>
        <div class="mt-5">
            <b-row>
                <b-col>
                    <div class="form-group">
                        <label class="form-label">
                            Nombre
                          <span class="text-danger">*</span>
                        </label>
                        <input
                            v-model.trim="$v.nombre.$model"
                            :class="{ 'is-invalid': $v.nombre.$error }"
                            type="text"
                            class="form-control"
                        />
                        <div class="invalid-feedback">
                            <span v-if="!$v.nombre.$required"
                                >Este campo es requerido</span
                            >
                        </div>
                    </div>
                </b-col>
                <b-col>
                    <div class="form-group">
                        <label class="form-label">
                            Apellido
                          <span class="text-danger">*</span>
                        </label>
                        <input
                            v-model.trim="$v.apellido.$model"
                            :class="{ 'is-invalid': $v.apellido.$error }"
                            type="text"
                            class="form-control"
                        />
                        <div class="invalid-feedback">
                            <span v-if="!$v.apellido.$required"
                                >Este campo es requerido</span
                            >
                        </div>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <div class="form-group">
                        <label class="form-label">
                            Correo electrónico
                          <span class="text-danger">*</span>
                        </label>
                        <input
                            v-model.trim="$v.email.$model"
                            :class="{ 'is-invalid': $v.email.$error }"
                            type="email"
                            class="form-control"
                        />
                        <div class="invalid-feedback">
                            <span v-if="!$v.email.$required"
                                >Este campo es requerido</span
                            >
                            <br />
                            <span v-if="!$v.email.$email"
                                >Formato de correo electrónico inválido</span
                            >
                        </div>
                    </div>
                </b-col>
                <b-col>
                    <div class="form-group">
                        <label class="form-label">
                            Celular
                          <span class="text-danger">*</span>
                        </label>
                        <input
                            v-model.number.lazy="$v.celular.$model"
                            :class="{ 'is-invalid': $v.celular.$error }"
                            type="text"
                            class="form-control"
                            maxlength="10"
                        />
                        <div class="invalid-feedback">
                            <span v-if="!$v.celular.$required"
                                >Este campo es requerido</span
                            >
                            <br />
                            <span v-if="!$v.celular.$numeric"
                                >Formato de teléfono inválido</span
                            >
                        </div>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <div class="form-group">
                        <label class="form-label">
                            Valor del vehículo
                        </label>
                        <vue-autonumeric
                            id="input-horizontal"
                            class="form-control"
                            v-model="v_vehiculo"
                            disabled
                            :options="optionsNumeric"
                        ></vue-autonumeric>
                    </div>
                </b-col>
                <b-col>
                    <div class="form-group">
                        <label class="form-label">
                            Valor a financiar
                        </label>
                        <vue-autonumeric
                            id="input-horizontal"
                            class="form-control"
                            v-model="vr_financiar"
                            disabled
                            :options="optionsNumeric"
                            placeholder="Valor a financiar"
                        ></vue-autonumeric>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <div class="form-group">
                        <label class="form-label">
                            Actividad Economica
                            <span class="text-danger">*</span>
                        </label>
                        <select
                            class="form-control"
                            :class="{ 'is-invalid': $v.actividad.$error }"
                            v-model="actividad"
                        >
                            <option value="">Seleccione...</option>
                            <option value="Empleado">Empleado</option>
                            <option value="Independiente - Prestador de servicios">Independiente - Prestador de servicios</option>
                            <option value="Independiente - Propietario de negocios">Independiente - Propietario de negocios</option>
                            <option value="Independiente - Rentista capital">Independiente - Rentista capital</option>
                            <option value="Pensionado/Jubilado">Pensionado/Jubilado</option>
                            <option value="Persona Juridica">Persona Juridica</option>
                            <option value="Profesional Independiente">Profesional Independiente</option>
                        </select>
                        <div class="invalid-feedback">
                            <span v-if="!$v.actividad.$required"
                                >Este campo es requerido</span
                            >
                        </div>
                    </div>
                </b-col>
                <b-col>
                    <div class="form-group">
                        <label class="form-label">
                            Ingresos
                        </label>
                        <vue-autonumeric
                            id="input-horizontal"
                            class="form-control"
                            v-model="ingresos"
                            :options="optionsNumeric"
                        ></vue-autonumeric>
                    </div>
                </b-col>
            </b-row>
            <div class="form-group">
                <label class="form-label">
                    Mensaje
                </label>
                <textarea
                    v-model="mensaje"
                    rows="2"
                    class="form-control"
                ></textarea>
            </div>
            <div class="form-group">
                <label>
                   <i class="fa fa-check-square" aria-hidden="true"></i>
                    Al solicitar tu credito estás aceptando
                    nuestra
                    <a
                        href="https://redautos.com/politica_tratamiento_datos_personales"
                        target="_blank"
                    >
                        Política de privacidad de datos personales
                    </a>
                </label>
            </div>
            <div class="form-group">
                <button
                    :disabled="onLoadForm"
                    class="btn btn-block"
                    type="submit"
                    @click="onCreditoForm"
                >
                    Aplicar a Credito
                    <clip-loader
                        :class="{ 'd-none': !onLoadForm }"
                        style="display: inline;margin-right: 10px;"
                        color="#fff"
                        size="15px"
                    ></clip-loader>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { required, email, numeric } from "vuelidate/lib/validators";
export default {
    computed: {
        ...mapFields("financiar", [
            "credito.v_vehiculo",
            "credito.vr_financiar",
            "credito.plazo",
            "credito.v_inicial",
            "cliente.nombre",
            "cliente.apellido",
            "cliente.email",
            "cliente.celular",
            "cliente.actividad",
            "cliente.ingresos",
            "cliente.mensaje",
            "asistente_step",
            "id_consignacion"
        ])
    },
    validations: {
        nombre: {
            required
        },
        apellido: {
            required
        },
        actividad: {
            required
        },
        email: {
            required,
            email
        },
        celular: {
            required,
            numeric
        }
    },
    data: () => ({
        onLoadForm: false,
        ifSuccess: false,
        marca_linea_version: "",
        optionsNumeric: [
            "integerPos",
            {
                digitGroupSeparator: ".",
                decimalCharacter: ",",
                minimumValue: "0",
                maximumValue: "300000000",
                caretPositionOnFocus: "start",
                currencySymbol: "$"
            }
        ]
    }),
    methods: {
        onCreditoForm() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                return (this.submitStatus = "False");
            } else {
                this.onLoadForm = true;
                var data = {
                    nombre: this.nombre,
                    apellido: this.apellido,
                    mensaje: this.mensaje,
                    id_consignacion: this.id_consignacion,
                    v_vehiculo: this.v_vehiculo,
                    v_inicial: this.v_inicial,
                    vr_financiar: this.vr_financiar,
                    plazo: this.plazo,
                    actividad: this.actividad,
                    ingresos: this.ingresos,
                    celular: this.celular,
                    email: this.email
                };
                axios.post("/credito_form", data).then(response => {
                    var responseData = response.data;
                    if (responseData.status === "success") {
                        this.onLoadForm = false;
                        window.location.href = '/financiar/response';
                        // if (this.id_consignacion != "") {
                        //     window.history.replaceState(
                        //         null,
                        //         null,
                        //         "?step=response&ficha_tecnica=" +
                        //             this.id_consignacion
                        //     );
                        // } else {
                        //     window.history.replaceState(
                        //         null,
                        //         null,
                        //         "?step=response"
                        //     );
                        // }
                    }
                });
            }
        }
    }
};
</script>

<style lang="scss">
h5.text-red {
    color: #fa2837;
}
</style>
